parseTokenHH